function safeTrim(value) {
  return String(value ?? '').trim();
}

function toInt(value) {
  if (value == null) return 0;
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return 0;
    return Math.max(0, Math.trunc(value));
  }

  const s = String(value).trim();
  if (!s) return 0;

  const cleaned = s
    .replace(/[,$]/g, '')
    .replace(/[()]/g, '')
    .replace(/[^\d.+-]/g, '');
  const n = Number(cleaned);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.trunc(n));
}

export function buildSugarNoteTextForCustomer({ customer, rows, shipToCode }) {
  const itemRows = Array.isArray(rows)
    ? rows.filter((row) => toInt(row?.order_qty ?? row?.orderQty ?? 0) > 0)
    : [];

  const customerName = safeTrim(customer?.customer_name ?? customer?.customerName);
  const customerNo = safeTrim(customer?.customer_no ?? customer?.customerNo);
  const street = safeTrim(customer?.facility_address ?? customer?.facilityAddress);
  const city = safeTrim(customer?.ship_to_city ?? customer?.shipToCity);
  const state = safeTrim(customer?.ship_to_state ?? customer?.shipToState);
  const zipCode = safeTrim(customer?.ship_to_zip ?? customer?.shipToZip);
  const shipTo = safeTrim(shipToCode || customer?.ship_to_code || customer?.shipToCode);

  const cityStateZip =
    city || state || zipCode
      ? `${city}${city && state ? ', ' : ''}${state}${zipCode ? ` ${zipCode}` : ''}`
      : '';

  const lines = [
    `Customer: ${customerName || customerNo || 'Unknown customer'}`,
    `Customer No: ${customerNo || 'Unknown'}`,
    `Ship To: ${shipTo || 'Unknown'}`,
    `Address: ${[street, cityStateZip].filter(Boolean).join(', ') || 'Unknown address'}`,
    '',
    ...itemRows.map((row) => {
      const item = safeTrim(row?.itemno ?? row?.itemNo ?? row?.partNo);
      const qty = toInt(row?.order_qty ?? row?.orderQty ?? 0);
      const uom = safeTrim(row?.uom || row?.unitOfMeasure || row?.unit_of_measure || 'EA');
      const description = safeTrim(
        row?.description ||
          row?.item_description ||
          row?.itemDescription ||
          row?.itemDesc ||
          row?.ItemDesc ||
          row?.customer_note ||
          row?.customerNote ||
          ''
      );

      const prefix = item ? `Part NO: ${item} Qty:${qty} ${uom}` : `Qty:${qty} ${uom}`;
      return description ? `${prefix} - ${description}` : prefix;
    }),
  ];

  return lines.join('\n').trim();
}
